const SUBURB_REDIRECTS = {
  'caloundra-west': {
    slug: 'caloundra-qld',
    suburb: 'Caloundra',
    state: 'QLD',
  },
  'townsville-city-qld': {
    slug: 'townsville-qld',
    suburb: 'Townsville',
    state: 'QLD',
  },
  'mackay-mc': {
    slug: 'mackay-qld',
    suburb: 'Mackay',
    state: 'QLD',
  },
  'tweed-heads': {
    slug: 'tweed-heads-nsw',
    suburb: 'Tweed Heads',
    state: 'NSW',
  },
  'bundaberg-central': {
    slug: 'bundaberg-qld',
    suburb: 'Bundaberg',
    state: 'QLD',
  },
  'bundaberg-east-qld': {
    slug: 'bundaberg-qld',
    suburb: 'Bundaberg',
    state: 'QLD',
  },
  'gold-coast-south-qld': {
    slug: 'gold-coast-qld',
    suburb: 'Gold Coast',
    state: 'QLD',
  },
  castletown: {
    slug: 'hyde-park-qld',
    suburb: 'Hyde Park',
    state: 'QLD',
  },
  'south-kempsey-nsw': {
    slug: 'kempsey-nsw',
    suburb: 'Kempsey',
    state: 'NSW',
  },
  'hunter-valley-nsw': {
    slug: 'maitland-nsw',
    suburb: 'Maitland',
    state: 'NSW',
  },
  'upper-hunter-valley-region': {
    slug: 'scone',
    suburb: 'Scone',
    state: 'NSW',
  },
};

export default SUBURB_REDIRECTS;
